"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const AppBar = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const ref = (0, _react.useRef)();
  const theme = (0, _material.useTheme)();
  const [height, setHeight] = (0, _react.useState)(0);
  const fixedAppBar = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
  theme.palette.mode = 'light';
  const timeout = theme.transitions.duration.shortest;
  const appBarElement = ref.current;
  (0, _react.useEffect)(() => {
    let intervalId;
    if (appBarElement) {
      intervalId = setInterval(() => {
        const {
          clientHeight
        } = appBarElement;
        setHeight(clientHeight);
      }, timeout);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [appBarElement, fixedAppBar, timeout]);
  const sameHeight = height === _lodash.default.get(ref, 'current.clientHeight');
  const position = fixedAppBar && sameHeight ? 'fixed' : 'static';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.AppBar, _extends({}, props, {
    ref: ref,
    position: position
  }), children), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      height: position === 'fixed' ? height : 0
    }
  }));
};
AppBar.defaultProps = {
  color: 'site'
};
var _default = exports.default = AppBar;